// Genera il contenuto del QR code nel formato atteso da "Gestione Sagra"
// (GestioneStandGastronomico), ricostruito decompilando il parser Python
// del programma (funzione `aggiorna_ordine_da_barcode` in ordini.pyc, v2.3.6):
//
//   {
//     "numeroTavolo": <string>,
//     "cliente": <string>,
//     "coperti": <string>,
//     "note": <string, opzionale>,        ← note a livello ORDINE
//     "righe": [{
//       "id": <int articolo>,
//       "qta": <int>,
//       "ingredienti": [{ "id": <int articolo_ingrediente>, "qta": <int> }]
//                                          ↑ SEMPRE presente: se l'articolo ha
//                                          ingredienti configurati nel DB e la
//                                          chiave manca, il parser RIFIUTA
//                                          l'intero ordine ("Errore nella
//                                          lettura del QRCode")
//     }]
//   }
//   → encodeURIComponent(JSON.stringify(...))
//
// Gli ingredienti opzionali selezionati compaiono in stampa come
// "<Piatto> con <INGREDIENTE>" (es. "Pasta bianca con SENZA LATTOSIO").
// Il software di cassa fa unquote + json.loads sulla stringa digitata
// dalla pistola.

export type OrderIngredient = {
  id: number
  qta: number
}

export type OrderRow = {
  id: number
  qta: number
  ingredienti: OrderIngredient[]
}

export type OrderPayload = {
  numeroTavolo: string
  righe: OrderRow[]
  cliente?: string
  coperti?: string
  note?: string
}

export function buildOrderPayload(
  numeroTavolo: string,
  righe: OrderRow[],
  extra?: { cliente?: string; note?: string },
): string {
  const obj: OrderPayload = {
    numeroTavolo: numeroTavolo,
    righe: righe.map((r) => ({
      id: r.id,
      qta: r.qta,
      ingredienti: r.ingredienti.map((i) => ({ id: i.id, qta: i.qta })),
    })),
  }
  const cliente = extra?.cliente?.trim()
  if (cliente) obj.cliente = cliente
  const noteTrimmed = extra?.note?.trim()
  if (noteTrimmed) obj.note = noteTrimmed
  return encodeURIComponent(JSON.stringify(obj))
}
